import { Alert, Anchor, Paragraph } from '@zillow/constellation-10';

const CA_AB_723_URL = 'https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=202320240AB723';

const DigitallyAlteredPhotosAlert = () => {
  return (
    <Alert data-testid="DigitallyAlteredPhotosAlert" css={{ marginBottom: '400' }}>
      <Paragraph>
        <Anchor href={CA_AB_723_URL} target="_blank" rel="noopener noreferrer">
          California AB 723
        </Anchor>{' '}
        requires real-estate sales ads to label digitally altered photos and give viewers access to the original images.
        Review each photo and mark any digitally altered images.
      </Paragraph>
      <Paragraph css={{ marginTop: '300' }}>
        <strong>What counts:</strong> Adding, removing, or changing furniture, property features, or views — for
        example, virtually staging a room, removing a wall, or changing the view outside a window.
      </Paragraph>
      <Paragraph css={{ marginTop: '300' }}>
        <strong>What doesn’t:</strong> Routine lighting adjustments or cropping, as long as they don’t change how the
        property is represented.
      </Paragraph>
    </Alert>
  );
};

export default DigitallyAlteredPhotosAlert;
